import gql from 'graphql-tag';
import { GqlTag, GqlTagFragment } from '../fragments/tag';

export const MUTATION = gql`
  mutation DismissYardstikAd {
    dismissYardstikAd {
      showYardstikAd
    }
  }
`;
